STUDIP.domReady(function() {
    if ($('.sem-tree-assigned-root > ul > li').length == 0) {
        $('.sem-tree-assigned-root').addClass('hidden-js');
    }
});
